export default [
  [
    {
      id: 'refId',
      span: 6,
      type: 0,
      label: 'เลขที่ใบแจ้งซ่อม',
      props: { padding: '8px 0' },
    }, {
      id: 'result',
      span: 6,
      offset: 0,
      type: 11,
      props: { padding: '8px 0' },
    }, {
      id: 'isPending',
      span: 4,
      type: 12,
      label: 'สถานะรถ',
      props: { padding: '8px 0' },
    }, {
      id: 'warehouseId',
      span: 4,
      type: 13,
      label: 'สาขา *',
      props: { padding: '8px 0' },
    }, {
      id: 'deadlineDate',
      span: 4,
      type: 8,
      label: 'กำหนดวันที่ซ่อมเสร็จ *',
      props: { padding: '8px 0' },
    }, {
      id: 'truckId',
      span: 6,
      type: 1,
      label: 'ทะเบียนรถ *',
      disabled: true,
    }, {
      id: 'truckType',
      span: 2,
      offset: 0,
      type: 3.1,
      label: 'ชนิดรถ',
      props: { padding: '8px 0' },
    }, {
      id: 'driverName',
      span: 4,
      offset: 0,
      type: 3.2,
      label: 'พนักงานขับรถ',
      props: { padding: '8px 0' },
    }, {
      id: 'phoneNumber',
      span: 4,
      offset: 0,
      type: 3.3,
      label: 'เบอร์โทรศัพท์',
      props: { padding: '8px 0' },
    },
    {
      id: 'currentFuel',
      span: 4,
      offset: 0,
      type: 9,
      label: 'น้ำมันที่เหลือ (ลิตร) *',
      unit: 'ลิตร',
      props: { padding: '8px 0' },
    }, {
      id: 'currentMile',
      span: 4,
      type: 9,
      label: 'ไมล์เข้า (ไมล์) *',
      unit: 'ไมล์',
      props: { padding: '8px 0' },
    },
    {
      id: 'divider',
      type: 17,
    },
    {
      id: 'header',
      type: 18,
    },
    {
      id: 'isRepairTruck',
      span: 3,
      type: 1.2,
      label: 'ซ่อมรถบรรทุก',
      disabled: true,
    },
    {
      id: 'repairTruckType',
      span: 6,
      type: 15,
      label: 'หมวดหมู่ซ่อมรถบรรทุก',
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTruck',
    },
    {
      id: 'repairTruckTypeOther',
      span: 15,
      type: 16,
      label: 'กรอกรายละเอียดหมวดหมู่ซ่อมเพิ่มเติม',
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTruck',
      enableOtherKey: 'repairTruckType',
    },
    {
      id: 'isRepairTrailer',
      span: 3,
      type: 1.2,
      label: 'ซ่อมหางพ่วง',
      disabled: true,
    },
    {
      id: 'trailerId',
      span: 3,
      type: 1.1,
      label: 'ทะเบียนหางพ่วง',
      disabled: true,
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTrailer',
    },
    {
      id: 'trailerStatus',
      span: 3,
      type: 1.3,
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTrailer',
    },
    {
      id: 'repairTrailerType',
      span: 6,
      type: 15,
      label: 'หมวดหมู่ซ่อมหางพ่วง',
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTrailer',
    },
    {
      id: 'repairTrailerTypeOther',
      span: 9,
      type: 16,
      label: 'กรอกรายละเอียดหมวดหมู่ซ่อมเพิ่มเติม',
      props: {
        style: {
          padding: '8px 6px',
        },
      },
      enableKey: 'isRepairTrailer',
      enableOtherKey: 'repairTrailerType',
    },
    {
      id: 'description',
      span: 24,
      type: 7,
      label: 'รายละเอียดของปัญหา',
      props: { padding: '8px 0' },
    }, {
      id: 'options',
      span: 24,
      type: 10,
      props: { margin: '8px 0' },
    },
  ], [
    {
      id: 'expense',
      span: 4,
      type: 9.1,
      label: ' ค่าแรง/ค่าใช้จ่ายเพิ่มเติม',
      unit: 'บาท',
      props: { padding: '8px 0' },
    }, {
      id: 'price',
      span: 4,
      type: 9.1,
      label: 'ค่าอะไหล่ซื้อ',
      unit: 'บาท',
      props: { padding: '8px 0' },
    }, {
      id: 'tireCarrierDriverId',
      span: 4,
      type: 9.3,
      label: 'พนักงานส่งยาง',
      props: { padding: '8px 0' },
    }, {
      id: 'expenseTire',
      span: 4,
      type: 9.2,
      label: 'ค่าเบี้ยเลี้ยงส่งยาง',
      unit: 'บาท',
      props: { padding: '8px 0' },
    },
  ], [
    {
      id: 'partCost',
      span: 4,
      type: 14.1,
      label: 'ค่าอะไหล่ที่เบิก',
    }, {
      id: 'TireCost',
      span: 4,
      type: 14.2,
      label: 'ค่ายางที่เบิก',
    }, {
      id: 'totalCost',
      span: 4,
      type: 14.3,
      label: 'ค่าใช้จ่ายรวม',
    },
  ], [
    {
      id: 'remark',
      span: 24,
      type: 7,
      label: 'หมายเหตุ',
      props: { padding: '8px 0' },
    }, {
      id: 'files',
      span: 24,
      type: 5,
      props: { margin: '8px 0' },
    },
  ],
]
